import {
  faBan,
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./booking.css";

export interface AvailabilitySlotItem {
  start: string;
  end: string;
  state: "free" | "busy" | "unavailable";
  selectable: boolean;
  detail?: string | null;
}

/** Presentation only: callers retain loading, scheduling and permission rules. */
export default function AvailabilitySlotGrid({
  items,
  selectedHour,
  onSelect,
}: {
  items: AvailabilitySlotItem[];
  selectedHour?: string | null;
  onSelect?: (start: string) => void;
}) {
  return (
    <ul className="availability-slots list-unstyled mb-0">
      {items.map(({ start, end, state, selectable: allowed, detail }) => {
        const busy = state === "busy";
        const off = state === "unavailable";
        const selectable = allowed && !!onSelect;
        const selected = selectedHour === start;
        const label = `${start} – ${end} ${busy ? "occupé" : off ? "indisponible" : "libre"}${detail ? ` ${detail}` : ""}`;
        const content = (
          <>
            <span className="availability-slot__time">
              {start} – {end}
            </span>
            <span className="availability-slot__state">
              <FontAwesomeIcon
                icon={
                  selected
                    ? faCircleCheck
                    : busy
                      ? faCircleXmark
                      : off
                        ? faBan
                        : faCircleCheck
                }
                aria-hidden="true"
              />
              <span>
                {selected
                  ? `Sélectionné${busy ? " · Occupé" : off ? " · Indisponible" : ""}`
                  : detail ?? (busy ? "Occupé" : off ? "Indisponible" : "Libre")}
              </span>
            </span>
          </>
        );
        const className = `availability-slot availability-slot--${state}${selected ? " availability-slot--selected" : ""}${selectable ? " availability-slot--selectable" : ""}`;
        return (
          <li
            key={start}
            aria-label={selectable ? undefined : label}
          >
            {selectable ? (
              <button
                type="button"
                aria-label={label}
                aria-pressed={selected}
                title={busy ? (detail ?? undefined) : undefined}
                className={className}
                onClick={() => onSelect?.(start)}
              >
                {content}
              </button>
            ) : (
              <div
                title={busy ? (detail ?? undefined) : undefined}
                className={className}
              >
                {content}
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
